import moment from "moment";
import React from "react";
import { PRESCRIPTION_OPTIONS } from "../../../common/constant/common-constants";
import "./PrescriptionTable.scss";
import { Fragment } from "react";
import { useEffect, useState } from "react";

export function PrescriptionTable(props) {
    const HEADER_LIST = ["ACTION", "DRUG NAME", "DOSAGE", "ROUTE", "FREQUENCY", "START TIME", "SPECIAL INSTRUCTIONS"];
    const ACTIONS = {
        DEFAULT: "DEFAULT",
        STOP: "STOP",
        CONTINUE: "CONTINUE"
    }
    const [dataArr, setDataArr] = useState([]);

    const handleChange = (parameter, data, index, newData) => {
        // console.log("row: " + JSON.stringify(row) + " ,data: " + data + " ,index: " + index + " ,newData: " + newData);

        props.handleChange(parameter, data, index, newData);
    }
    useEffect(() => {
        if (props.data) {
            props.data.sort((a, b) => a.id - b.id)
            // console.log(props.data)
            setDataArr(props.data);
        }

    }, [props.data])

    const handleActionClick = (id, action) => {

        let data = {
            id: id,
            action: action
        }

        props.handleUpdatePrescription(data);
    }

    return (
        <div className="prescription-table-container">
            <div className="prescription-table-header">
                <div className="prescription-heading-text">
                    {props.date ? `Medication for ${moment(props.date).format("MM/DD/YYYY")}` :
                        'Please select a date to view Medications'}
                </div>
            </div>
            {props.data && props.data.length > 0 && <table className="prescription-table">
                <thead >
                    <tr>
                        {[PRESCRIPTION_OPTIONS.DRUGS, PRESCRIPTION_OPTIONS.STAT_ORDERS].includes(props.type)
                            && HEADER_LIST.map((header, count) => {
                                if (props.type === PRESCRIPTION_OPTIONS.STAT_ORDERS && header === "FREQUENCY") return; {/* to hide frequency in stat orders */ }
                                return <th key={count} className="prescription-drug-header">
                                    {header}
                                </th>
                            })}
                    </tr>
                    {
                        PRESCRIPTION_OPTIONS.INFUSION === props.type &&
                        <>
                            <tr>
                                <th rowSpan="2" >ACTION</th>
                                <th rowSpan="2" >INFUSION NAME</th>
                                <th rowSpan="2" >VOLUME</th>
                                <th colSpan="2" >ADDITIVES</th>
                                <th rowSpan="2" >DURATION</th>
                                {/* <th rowSpan="2" >FREQUENCY</th> */}
                                <th rowSpan="2" >RATE</th>
                                <th rowSpan="2">START TIME</th>
                                <th rowSpan="2" >SPECIAL INSTRUCTIONS</th>
                            </tr>
                            <tr>
                                <th scope="col">NAME</th>
                                <th scope="col">DOSAGE</th>
                            </tr>
                        </>
                    }
                </thead >
                <tbody >
                    {
                        [PRESCRIPTION_OPTIONS.DRUGS, PRESCRIPTION_OPTIONS.STAT_ORDERS].includes(props.type) &&
                        dataArr && dataArr.map((row, count) => {
                            return (
                                <tr key={count}>
                                    <td>
                                        <div className="start-stop-container">
                                            {[ACTIONS.CONTINUE, ACTIONS.DEFAULT].includes(row.action) &&
                                                <div className="stop-button action-button"
                                                    onClick={() => handleActionClick(row.id, ACTIONS.STOP)}>
                                                    STOP
                                                </div>}
                                            {[ACTIONS.STOP, ACTIONS.DEFAULT].includes(row.action) &&
                                                <div className="start-button action-button"
                                                    onClick={() => handleActionClick(row.id, ACTIONS.CONTINUE)}>
                                                    CONTINUE
                                                </div>}
                                        </div>
                                    </td>
                                    {
                                        <>
                                            <td width="25%">
                                                {row.name}
                                            </td>
                                            <td>
                                                {row.dosage}
                                            </td>
                                            <td>
                                                {row.route}
                                            </td>
                                            {/* to hide frequency in stat orders */}
                                            {props.type === PRESCRIPTION_OPTIONS.DRUGS && <td>
                                                {row.frequency === "" ? "-" : row.frequency}
                                            </td>}
                                            <td>
                                                {row.startTime || '-'}
                                            </td>
                                            <td>
                                                {row.remarks}
                                            </td>
                                        </>
                                    }
                                </tr>
                            )
                        })
                    }
                    {
                        PRESCRIPTION_OPTIONS.INFUSION === props.type &&
                        dataArr && dataArr.map((row, count) => {

                            let rowSpan = row.additives && row.additives.length;
                            return (
                                <Fragment key={count}>
                                    <tr key={count}>
                                        {
                                            <>
                                                <td
                                                    rowSpan={rowSpan || 1} >
                                                    <div className="start-stop-container">
                                                        {[ACTIONS.CONTINUE, ACTIONS.DEFAULT].includes(row.action) &&
                                                            <div className="stop-button action-button"
                                                                onClick={() => handleActionClick(row.id, ACTIONS.STOP)}>
                                                                STOP
                                                            </div>}
                                                        {[ACTIONS.STOP, ACTIONS.DEFAULT].includes(row.action) &&
                                                            <div className="start-button action-button"
                                                                onClick={() => handleActionClick(row.id, ACTIONS.CONTINUE)}>
                                                                CONTINUE
                                                            </div>}
                                                    </div>
                                                </td>
                                                <td rowSpan={rowSpan || 1} width="25%">
                                                    {row.name}
                                                </td>
                                                <td rowSpan={rowSpan || 1}>
                                                    {row.volume}
                                                </td>
                                                <td >
                                                    {
                                                        (rowSpan && row.additives[0].name) || "-"
                                                    }
                                                </td>
                                                <td >
                                                    {
                                                        (rowSpan && row.additives[0].dosage) || "-"
                                                    }
                                                </td>
                                                <td rowSpan={rowSpan || 1}>
                                                    {row.duration === "" ? "-" : row.duration}
                                                </td>
                                                {/* <td rowSpan={rowSpan || 1}>
                                                    {row.frequency === "" ? "-" : row.frequency}
                                                </td> */}
                                                <td rowSpan={rowSpan || 1}>
                                                    {row.rate}
                                                </td>
                                                <td rowSpan={rowSpan || 1}>
                                                    {row.startTime || '-'}
                                                </td>
                                                <td rowSpan={rowSpan || 1}>
                                                    {row.remarks}
                                                </td>
                                            </>
                                        }
                                    </tr>
                                    {
                                        <>
                                            {row.additives && row.additives.map((additive, count) => {
                                                if (count > 0) {
                                                    return (<tr key={count}>
                                                        <td >
                                                            {additive.name}
                                                        </td>
                                                        <td >
                                                            {additive.dosage}
                                                        </td>
                                                    </tr>)
                                                }
                                            })}
                                        </>
                                    }
                                </Fragment>
                            )
                        })
                    }
                </tbody>
            </table>}
            {
                props.data && props.data.length <= 0 && <div className="empty-data-message">No Medication added for the selected Date</div>
            }
        </div >
    );
}